import React, { Children } from 'react';
import Collapse from 'react-bootstrap/Collapse';

import { IconType } from 'components/DesignSystem/Icon/icons';
import Suboption from './Suboption';
import SimpleOption from '../SimpleOption';

import './index.scss';

export default function ExpandableOption({
  label,
  icon,
  isCollapsed,
  children,
  expandedOption,
  setExpandedOption,
  locked = false,
  link = '#',
}: {
  label: string;
  icon: IconType;
  isCollapsed: boolean;
  children: any;
  expandedOption: string;
  setExpandedOption: React.Dispatch<React.SetStateAction<string>>;
  locked?: boolean;
  link?: string;
}) {
  const productLinks = Children.toArray(children) as React.ReactElement<any>[];
  const showOptions = (expandedOption === label);
  const onClick = showOptions
    ? () => setExpandedOption('')
    : () => setExpandedOption(label);

  return (
    <>
      <SimpleOption
        isCollapsed={isCollapsed}
        icon={icon}
        locked={locked}
        link={link}
        onClick={onClick}
      >
        {label}
      </SimpleOption>
      {!isCollapsed && (
        <Collapse in={showOptions}>
          <div className="sidebar-collapse-container">
            <div className="vertical-line" />
            <div className="expanded-section">
              {productLinks.map((productLink) => (
                <div key={productLink.key} className="sidebar-expanded-suboption">
                  {productLink}
                </div>
              ))}
            </div>
          </div>
        </Collapse>
      )}
    </>
  );
}

ExpandableOption.Option = Suboption;
